<div class="flex-shrink-0 w-40 snap-start group">
  <div class="relative bg-white rounded-lg border-2 border-gray-200 overflow-hidden transition-all hover:border-blue-400 hover:shadow-md">
    <!-- Image container with fixed aspect ratio -->
    <div class="relative w-40 h-40 bg-gray-50">
      <img 
        [src]="preview().url" 
        [alt]="preview().name"
        class="w-full h-full object-cover pointer-events-none"
      />
      
      <!-- Remove button -->
      <button
        type="button"
        (click)="onRemove()"
        class="absolute top-2 right-2 w-8 h-8 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center hover:bg-red-600 shadow-lg z-10"
        title="Remove image"
      >
        <img src="/delete.svg" alt="Remove" class="w-6 h-6" />
      </button>
    </div>
    
    <!-- Image info -->
    <div class="p-2 bg-gray-50 border-t border-gray-200">
      <p class="text-xs font-medium text-gray-700 truncate" [title]="preview().name">
        {{ preview().name }}
      </p>
      <p class="text-xs text-gray-500 mt-0.5">
        {{ preview().size }}
      </p>
    </div>
  </div>
</div>
